<template>
  <div>
    <div class="intelligent_scene_box" id="intelligent_scene">
      <div class="intelligent_scene_title">
        <span style="font-size: 1.6rem;font-weight: bold;display: block">数据智能化应用场景</span>
        <span style="color: #666666;font-size: 0.8rem;display: block;padding-top: 1rem">助力政企便捷管理 实现数据可视化场景化</span>
      </div>
      <div class="intelligent_scene_nav">
        <div class="intelligent_top_nav" slot="pagination" >
          <el-tabs v-model="activeIndex2" @tab-click="handleSelect2">
            <el-tab-pane  v-for="(item,index) in navList" :name="item.index" :key="index" class="item_padding">
              <img  slot="label" :src="item.blueIcon" v-if="activeIndex2===item.index" alt="" class="small_icon"/>
              <img  slot="label" :src="item.icon" alt="" v-else class="small_icon"/>
              <span slot="label" :class="activeIndex2===item.index?'is_active_tabs':'not_active_tabs'"> {{ item.title }}</span>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div>
          <div  class="recommend_nav">
            <swiper :options="swiperOption" ref="indexSwiper" >
              <swiper-slide  class="intelligent_scene_content" >
                <div class="content_left_image">
                  <img src="../assets/image/index/dataImg.webp" style="width: 100%;height: auto;-webkit-user-drag: none" alt=""/>
                </div>
                <div class="content_right_word">
                  <p>大数据</p>
                  <span  class="content_word_span" >利用行为分析算法，先后为金融、加工企业、快销品品牌商等，提供市场数据调研、市场营销、精准获客提供相应解决方案，以解决企业实际业务问题为目标，使数据的价值在场景应用中体现。</span>
                </div>
              </swiper-slide>

              <swiper-slide class="intelligent_scene_content" >
                <div class="content_left_image">
                  <img src="../assets/image/index/IOTImg.webp" style="width: 100%;height: auto;-webkit-user-drag: none" alt=""/>
                </div>
                <div class="content_right_word">
                  <p >IOT联网</p>
                  <span  class="content_word_span" >依托IOT物联网解决方案，打通各节点物理设备与业务系统运营的逻辑关系为客户提供低延时，高效的设备管理方案，提升场景设备的可靠性，有效支撑场景运作。</span>
                </div>
              </swiper-slide>

              <swiper-slide  class="intelligent_scene_content">
                <div class="content_left_image">
                  <img src="../assets/image/index/cityImg.webp" style="width: 100%;height: auto;-webkit-user-drag: none" alt=""/>
                </div>
                <div class="content_right_word">
                  <p >智慧城市</p>
                  <span  class="content_word_span" >全融合全云化平台，智能监控设备架设及智能联防，服务于智慧城市、平安城市、雪亮工程、智慧社区等项目，完成近3万路雪亮工程三类摄像头监控与接入。</span>
                </div>
              </swiper-slide>

              <swiper-slide   class="intelligent_scene_content">
                <div class="content_left_image">
                  <img src="../assets/image/index/AIImg.webp" style="width: 100%;height: auto;-webkit-user-drag: none" alt=""/>
                </div>
                <div class="content_right_word">
                  <p >视图AI场景</p>
                  <span  class="content_word_span" >针对企业需求，提供AI建模、云端训练、综合部署一站式服务，如“明厨亮灶”、“电梯视觉”、“轨迹追踪”等视图AI场景。</span>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="case_display_box" id="case_display">
      <div class="case_display_title">
        <span>案例展示</span>
      </div>
      <div class="smart_community_box">
        <div class="smart_community_left">
          <div class="smart_community_title" @click="toMore('smartCommunity','2-1')">
            <span  class="big_title" >智慧社区</span>
            <span  class="introduce_word">以全局视角掌控社区业务，打造新一代智慧社区，为社区治理、应急指挥等提供有效支撑。</span>
          </div>
          <button class="smart_community_btn" @click="toMore('smartCommunity','2-1')">查看更多</button>
        </div>
        <div class="smart_community_right">
          <img src="../assets/image/index/smartImg.webp" class="smart_community_image" alt="" @click="toMore('smartCommunity','2-1')" />
        </div>
      </div>

    </div>
    <div class="big_data_box" id="big_data">
      <div  class="big_data_inside">
        <div class="big_data_left">
          <img src="../assets/image/index/bigDataImg.webp" style="width: 100%;height: auto;-webkit-user-drag: none" alt="" @click="toMore('bigData','2-2')"/>
        </div>
        <div class="big_data_right">
          <div class="smart_community_title" @click="toMore('bigData','2-2')">
            <span class="big_title">BIG DATA</span>
            <span class="introduce_word">依靠分布式数据采集和大数据预存储系统，以开发人员为本的角度简化API使用以提升开发体验。</span>
          </div>
          <button class="smart_community_btn" @click="toMore('bigData','2-2')">查看更多</button>

        </div>

      </div>
    </div>
    <div class="company_data_box" id="company_data">
      <div class="company_data_title">
        <span>企业实力数据</span>
      </div>
      <div class="company_data_content">
        <div class="one_content_list" v-for="(item,index) in companyData" :key="index">
          <div  class="one_content_image">
            <img :src="item.image" style="width: 100%;height: auto;-webkit-user-drag: none" alt=""/>
          </div>
          <div style="font-size: 1.4rem;font-weight: 500;padding: 1rem 0;text-align: center">
            <span>{{item.num}}</span>
          </div>
          <div style="width: 44px;height: 1px;background-color: #3271FF;margin: 0 auto"></div>
          <div style="font-size: 1rem;color: #666666;padding: 1rem 0;text-align: center">
            <span>{{item.word}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="digital_service_process" id="digital_service">
      <div class="digital_service_title">
        <span>数字化服务流程</span>
      </div>
      <div class="digital_service_content" v-if="smallWidth===0">
        <div class="list_digital_service">
          <div style="display: flex;align-items: center;" v-for="(item,index) in processList" :key="index" >
            <div class="process_image_word">
              <img :src="item.image1" class="process_one_image" alt=""/>
              <span class="process_image_span">{{ item.title }}</span>
            </div>
            <div class="arrow_style">
              <img :src="item.image2" class="arrow_style_image" alt=""/>
            </div>
          </div>
          <div class="center_arrow_style">
            <div class="process_image_word">
              <img src="../assets/image/index/process3.webp" class="process_one_image" alt=""/>
              <span class="process_image_span">3.定制数字化解决方案</span>
            </div>
            <img src="../assets/image/index/arrowDown.webp" style="-webkit-user-drag: none;" alt=""/>
          </div>
        </div>
        <div class="list_digital_service">
          <div style="display: flex;align-items: center;" v-for="(item,index) in processArr" :key="index" >
            <div class="process_image_word">
              <img :src="item.image1"  class="process_one_image" alt=""/>
              <span class="process_image_span">{{ item.title }}</span>
            </div>
            <div class="arrow_style">
              <img :src="item.image2" class="arrow_style_image" alt=""/>
            </div>
          </div>
          <div class="process_image_word">
            <img src="../assets/image/index/process6.webp" class="process_one_image" alt=""/>
            <span class="process_image_span">4.初步测试， 部署数字化模型</span>
          </div>
        </div>
      </div>
      <div class="digital_service_content" v-if="smallWidth===1">
        <div class="small_digital_service" v-for="(item,index) in allProcess" :key="index">
          <div style="display: flex;align-items: center;flex-direction: column"  >
            <div class="process_image_word">
              <img :src="item.image1" class="process_one_image" alt=""/>
              <span class="process_image_span">{{ item.title }}</span>
            </div>
            <div class="arrow_style">
              <img :src="item.image2" alt="" v-if="item.image2"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cooperative_unit_box" id="cooperative_unit">
      <div class="cooperative_unit_title">
        <span>合作单位</span>
      </div>
      <div class="cooperative_unit_content">
        <img :src="item.logo"  v-for="(item,index) in companyList" :key="index" style="-webkit-user-drag: none;" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "index",
  components: {swiper, swiperSlide},
  data(){
    const that = this;
    return{
      activeIndex2:'1',
      navList:[
        {index:'1',title:'大数据',blueIcon:require('../assets/image/index/blueData.webp'),icon:require('../assets/image/index/data.webp')},
        {index:'2',title:'IOT联网',blueIcon:require('../assets/image/index/blueIOT.webp'),icon:require('../assets/image/index/IOT.webp')},
        {index:'3',title:'智慧城市',blueIcon:require('../assets/image/index/blueCity.webp'),icon:require('../assets/image/index/city.webp')},
        {index:'4',title:'视图AI场景',blueIcon:require('../assets/image/index/blueAI.webp'),icon:require('../assets/image/index/AI.webp')},
      ],
      contentList:[
        {index:'1',title:'大数据',content:'利用行为分析算法，先后为金融、加工企业、快销品品牌商等，提供市场数据调研、市场营销、精准获客提供相应解决方案，以解决企业实际业务问题为目标，使数据的价值在场景应用中体现。',image:require('../assets/image/index/dataImg.webp')},
        {index:'2',title:'IOT联网',content:'依托AWS IOT物联网解决方案，打通各节点物理设备与业务系统运营的逻辑关系为客户提供低延时，高效的设备管理方案，提升场景设备的可靠性，有效支撑场景运作。',image:require('../assets/image/index/IOTImg.webp')},
        {index:'3',title:'智慧城市',content:'全融合全云化平台，智能监控设备架设及智能联防，服务于智慧城市、平安城市、雪亮工程、智慧社区等项目，完成近3万路雪亮工程三类摄像头监控与接入。',image:require('../assets/image/index/cityImg.webp')},
        {index:'4',title:'视图AI场景',content:'针对企业需求，提供AI建模、云端训练、综合部署一站式服务，如“明厨亮灶”、“电梯视觉”、“轨迹追踪”等视图AI场景。',image:require('../assets/image/index/AIImg.webp')},
      ],
      companyData:[
        {id:1,num:'5000+',image:require('../assets/image/index/company_1.webp'),word:'政企用户'},
        {id:2,num:'500万+',image:require('../assets/image/index/company_2.webp'),word:'在线用户'},
        {id:3,num:'1亿+',image:require('../assets/image/index/company_3.webp'),word:'累计调用'},
        {id:4,num:'5万+',image:require('../assets/image/index/company_4.webp'),word:'终端设备'},
      ],
      processList:[
        {id:1,image1:require('../assets/image/index/process1.webp'),image2:require('../assets/image/index/arrowRight.webp'),title:'1.实地调研数字化现状'},
        {id:2,image1:require('../assets/image/index/process2.webp'),image2:require('../assets/image/index/arrowRight.webp'),title:'2.洞悉数字化痛点'},
      ],
      processArr:[
        {id:1,image1:require('../assets/image/index/process4.webp'),image2:require('../assets/image/index/arrowLeft.webp'),title:'6.一对一专人售后'},
        {id:2,image1:require('../assets/image/index/process5.webp'),image2:require('../assets/image/index/arrowLeft.webp'),title:'5.调试数字化模型 追踪进程'},
      ],
      allProcess:[
        {id:1,image1:require('../assets/image/index/process1.webp'),image2:require('../assets/image/index/arrowDown.webp'),title:'1.实地调研数字化现状'},
        {id:2,image1:require('../assets/image/index/process2.webp'),image2:require('../assets/image/index/arrowDown.webp'),title:'2.洞悉数字化痛点'},
        {id:3,image1:require('../assets/image/index/process3.webp'),image2:require('../assets/image/index/arrowDown.webp'),title:'3.定制数字化解决方案'},
        {id:4,image1:require('../assets/image/index/process4.webp'),image2:require('../assets/image/index/arrowDown.webp'),title:'4.初步测试， 部署数字化模型'},
        {id:5,image1:require('../assets/image/index/process5.webp'),image2:require('../assets/image/index/arrowDown.webp'),title:'5.调试数字化模型 追踪进程'},
        {id:6,image1:require('../assets/image/index/process6.webp'),image2:null,title:'6.一对一专人售后'},
      ],
      companyList:[
        {id:1,logo:require('../assets/image/index/company1.png')},
        {id:2,logo:require('../assets/image/index/company2.png')},
        {id:3,logo:require('../assets/image/index/company3.png')},
        {id:4,logo:require('../assets/image/index/company4.png')},
        {id:5,logo:require('../assets/image/index/company5.png')},
        {id:6,logo:require('../assets/image/index/company6.png')},
      ],
      timer:'',
      swiperOption:{
        loop: true,
        autoplay: {
          delay: 8000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        on: {
          slideChangeTransitionStart: function(){
            let index = this.activeIndex===5?1:this.activeIndex;
            that.activeIndex2 = String(index);
          },

        }
      }

    }
  },
  props:{
    smallWidth:{
      type:Number
    }
  },
  computed: {
    swiper() {
      return this.$refs.indexSwiper.swiper;
    }
  },
  metaInfo:{
    title:'厦门乐榜网络科技有限公司_乐榜官网',
    meta:[{
      name:'厦门乐榜网络科技有限公司_乐榜官网',
      content:'厦门乐榜网络科技有限公司_乐榜官网'
    },{
      name:'description',
      content:'厦门乐榜网络科技有限公司_乐榜官网'
    }]
  },
  methods:{
    handleSelect2(key){
      this.activeIndex2=key.name;
      let num=Number(key.name);
      this.swiper.slideTo(key.name, 1000, false);
    },
    toMore(path,key){
      let that=this;
      that.$router.push('/'+path);
      sessionStorage.setItem('active',key);
    },
  },
}
</script>

<style scoped>
.intelligent_scene_box{
  width: 100%;
  min-height: 36rem;
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
}
.intelligent_scene_title{
  width: 100%;
  height: 5rem;
  margin-top: 3rem;
  text-align: center;
}

.intelligent_scene_nav{
  width: 75%;
  min-height: 29rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding-bottom: 3rem;
}
.intelligent_top_nav{
  width: 100%;
  height: 8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.is_active_tabs{
  color:  rgb(64,158,255) !important;
}
.not_active_tabs{
  color:  #333333!important;
}
.blue_tile{
  color: rgb(64,158,255);
}
.normal_title{
  color: #222222;
}
.intelligent_top_nav /deep/ .el-tabs.el-tabs--top{
  width: 100%;
}
.intelligent_top_nav /deep/ .el-tabs__nav {
  height: 4.9rem;
  /*width: 1390px;*/
  display: flex;
  width: 100%;
}
.intelligent_top_nav /deep/ .el-tabs__item {
  height: 74px;
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 12px 0 rgba(206,225,240,0.38);
}
.intelligent_top_nav /deep/ .el-tabs__active-bar .is-top{
  width: 25%;
}
.intelligent_top_nav /deep/ .el-tabs__nav-wrap::after {
  background-color: rgba(0,0,0,0);
}
.intelligent_scene_content{
  width: 100%;
  min-height: 6rem;
  display: flex;
  justify-content: flex-start;
  box-shadow: 0 2px 12px 0 rgba(206, 225, 240, 0.38);
  border-radius: 10px;
}
.content_word_span{
  font-size: 1.2rem;
  display: block;
  color: #666666;
  font-weight: 400;
  margin-top: 26px;
  line-height: 28px;
}
.content_right_word p{
  font-size: 1.3rem;
  font-weight: 600
}
.content_left_image{
  width: 46%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content_right_word{
  width: 45%;
  min-height: 6rem;
  text-align: left;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 26px;
}
.case_display_box{
  width: 100%;
  min-height: 30rem;
  background: #F5F6F9;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.case_display_title{
  width: 100%;
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  padding: 3.7rem 0;
}
.smart_community_box{
  width: 100%;
  height: 23rem;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding-bottom: 3rem;
}
.smart_community_left{
  width: 39%;
  height: 23rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.smart_community_title{
  width: 100%;
  text-align: left;
}
.smart_community_btn{
  width: 11.75rem;
  height: 2.9rem;
  border: 1px solid #3271FF;
  color: #3271FF;
  background-color: rgba(0,0,0,0);
  margin: 3rem 0 0 0.5rem;
  cursor:pointer
}
.matrix_application_right{
  width:59%;
  height: 13.2rem;
}
.smart_community_right{
  width: 28%;
  height: 23rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.smart_community_image{
  width: 86%;
  height: auto;
  -webkit-user-drag: none;
}
.big_data_box{
  width: 100%;
  height: 22rem;
}
.big_data_inside{
  width: 75%;
  height: 23rem;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.big_data_left{
  width: 35%;
  height: 16.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.big_data_right{
  width: 48%;
  height: 16.5rem;
  display: flex;
  flex-direction: column;
}
.matrix_application_box{
  width: 60%;
  height: 22rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.matrix_application_left{
  width: 48%;
  height: 22rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.matrix_application_title{
  width: 100%;
  text-align: left;
}
.company_data_box{
  width: 100%;
  min-height: 35rem;
  display: flex;
  flex-direction: column;
  background-color: #F5F6F9;
}
.company_data_title{
  width: 100%;
  height: 9.75rem;
  text-align: center;
  line-height: 9.75rem;
  font-size: 1.5rem;
  font-weight: 600;
}
.company_data_content{
  width: 75%;
  min-height: 20rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.one_content_list{
  width: 24%;
  min-height: 14rem;
  box-shadow: 0 2px 12px 0 rgba(206, 225, 240, 0.38);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}
.one_content_image{
  width: 100%;
  height: auto;
}
.digital_service_process{
  width: 100%;
  min-height: 40rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #FFFFFF;
}
.digital_service_title{
  width: 100%;
  height: 9.75rem;
  text-align: center;
  line-height: 9.75rem;
  font-size: 1.5rem;
  font-weight: 600;
}
.digital_service_content{
  width: 75%;
  min-height: 27rem;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}
.list_digital_service:nth-of-type(1){
  width: 100%;
  height: 290px;
  display: flex;
  align-items: baseline;
  justify-content: center;
}
.list_digital_service:nth-of-type(2){
  width: 100%;
  height: 133px;
  display: flex;
  align-items: end;
  justify-content: center;
}
.process_image_word{
  width:198px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.process_image_span{
  padding: 0.5rem 0;
  font-size: 20px;
  width: 140px;
  text-align: center
}
.process_one_image{
  width: 61px;
  height: 61px;
  -webkit-user-drag: none;
}
.arrow_style{
  height:85px;
  display: flex;
  align-items: flex-end;
  padding: 1rem 2rem;
}
.center_arrow_style{
  width: 198px;
  height: 110px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.cooperative_unit_box{
  width: 100%;
  min-height: 345px;
  display: flex;
  flex-direction: column;
  background-color: #F5F6F9;
  padding-bottom: 20px;
}
.cooperative_unit_title{
  width: 100%;
  height: 9.75rem;
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  line-height: 9.75rem;
}
.cooperative_unit_content{
  width: 100%;
  min-height: 141px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}
.cooperative_unit_content img{
  margin:0 25px;
  padding: 5px;
  width: 10%;
  height: auto;
}
.cooperative_unit_content img:nth-of-type(5){
  margin:0 25px;
  padding: 5px;
  width: 7% !important;
  height: auto
}
.item_padding{
  padding: 0 5rem;
}
.big_title{
  display: block;
  font-size: 1.3rem;
  font-weight: 600;
  padding: 0 0.5rem;
  cursor:pointer
}
.introduce_word{
  display: block;
  font-size: 1rem;
  color: #666666;
  margin-top: 2rem;
  width: 83%;
  padding: 0 0.5rem;
  cursor:pointer
}
.small_icon{
  width: 52px;
  height: 48px;
  -webkit-user-drag: none;
}
@media (min-width: 1200px) {
  .intelligent_scene_content{
    width: 100%;
    min-height: 6rem;
    display: flex;
    align-items: center;
  }
  .intelligent_top_nav.el-tabs__nav {
    height: 4.9rem;
    width: 100%;
    display: flex;
  }
}
@media  (min-width: 979px) and (max-width: 1200px)  {
  .intelligent_scene_content{
    width: 100%;
    display: flex;
    align-items: center;
  }
  .intelligent_scene_nav{
    width: 92%;
    /*height: 35rem;*/
    margin: 0 auto;
    padding-bottom: 0;
  }
  .item_padding{
    padding: 1rem 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .big_data_inside{
    width: 75%;
    height: 23rem;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .process_image_word{
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .list_digital_service:nth-of-type(1) {
    width: 100%;
    height: 246px;
    display: flex;
    align-items: baseline;
    justify-content: center;
  }
  .arrow_style{
    height: 47px;
    display: flex;
    align-items: flex-end;
    width: 100px;
  }
  .arrow_style_image{
    width: 100%;
    height: auto;
    -webkit-user-drag: none;
  }
  .process_one_image{
    width: 52px;
    height: 50px;
    -webkit-user-drag: none;
  }
  .process_image_span{
    padding: 0.5rem 0;
    font-size: 16px;
    width: 140px;
    text-align: center;
  }
  .company_data_content{
    width: 80%;
  }
}

/* 平板电脑和小屏电脑之间的分辨率 */
@media (min-width: 768px) and (max-width: 979px) {
  .intelligent_scene_content{
    width: 100%;
    display: flex;
    align-items: center;
  }
  .intelligent_scene_nav{
    width: 92%;
    margin: 0 auto;
    padding-bottom: 0;
  }
  .case_display_title{
    width: 100%;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
    padding: 2.7rem 0;
  }
  .item_padding{
    padding: 0 2rem;
  }
  .smart_community_left{
    width: 46%;
    height: 23rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .smart_community_right{
    width: 43%;
    height: 23rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .smart_community_left{
    width: 46%;
    height: 23rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .smart_community_right{
    width: 35%;
    height: 23rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .big_data_inside{
    width: 83%;
    height: 23rem;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .matrix_application_box{
    width: 70%;
    height: 22rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .company_data_content{
    width: 92%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .process_image_word{
    width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .process_image_span{
    padding: 0.5rem 0;
    font-size: 14px;
    width: 100px;
    text-align: center
  }
  .arrow_style{
    height: 23px;
    width: 85px;
    display: flex;
    align-items: flex-end;
    padding: 0;
  }
  .arrow_style_image{
    width: 80%;
    height: auto;
    -webkit-user-drag: none;
  }
  .list_digital_service{
    width: 100%;
    height: 190px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cooperative_unit_content img{
    padding: 5px;
    width: 14%;
    height: auto;
  }
}

/* 横向放置的手机和竖向放置的平板之间的分辨率 */
@media (max-width: 768px) {
  .intelligent_scene_nav{
    width: 92%;
    margin: 0 auto;
    padding-bottom: 16px;
  }
  .item_padding{
    padding: 0 0.5rem;
  }

  .intelligent_scene_content{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 1rem 0;
  }
  .content_left_image {
    width: 65%;
  }
  .content_right_word {
    width: 66%;
  }
  .content_word_span{
    font-size: 16px;
    display: block;
    color: #666666;
    font-weight: 400;
    width: 100%;
    margin-top: 9px;
  }
  .small_icon{
    width: 32px;
    height: 32px;
    -webkit-user-drag: none;
  }
  .case_display_box{
    width: 100%;
    background: #F5F6F9;
    margin: 0 auto;
  }
  .smart_community_box{
    width: 100%;
    height: 38rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .smart_community_left{
    width: 100%;
    height: 17rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .smart_community_right{
    width: 100%;
    height: 23rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .smart_community_image{
    width: 61%;
    height: auto;
  }
  .big_data_box{
    width: 100%;
    height: 45rem;
  }
  .big_data_inside{
    width: 100%;
    height: 23rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .big_data_left{
    width: 100%;
    height: 30.5rem;
  }
  .big_data_right{
    width: 100%;
    height: 16.5rem;
    display: flex;
    flex-direction: column;
  }
  .matrix_application_box{
    width: 100%;
    height: 22rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
  }
  .matrix_application_left{
    width: 100%;
    height: 22rem;
    display: flex;
    flex-direction: column;
    justify-content: left;
  }

  .matrix_application_right{
    width: 100%;
    height: 13.2rem;
  }
  .company_data_content{
    width: 92%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: row;
    padding-bottom: 48px;
  }
  .one_content_list{
    width: 48%;
    margin-bottom: 1rem;
  }
  .one_content_image{
    width: 100%;
  }
  .process_image_word{
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .process_one_image{
    width: 40px;
    height: 40px;
    -webkit-user-drag: none;
  }
  .process_image_span{
    padding: 0.5rem 0;
    font-size: 16px;
    width: 110px;
    text-align: center
  }
  .arrow_style{
    height: 140px;
    width: 36px;
    display: flex;
    align-items: flex-start;
    padding: 0;
  }
  .arrow_style_image{
    width: 80%;
    height: auto;
    -webkit-user-drag: none;
  }
  .list_digital_service{
    width: 100%;
    height: 170px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cooperative_unit_content img{
    padding: 5px;
    width:24%;
    height: auto;
  }
  .list_digital_service:nth-of-type(1) {
    width: 100%;
    height: 200px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: baseline;
    justify-content: center;
  }
  .small_digital_service{
    width: 100%;
    height: 250px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .small_digital_service:nth-of-type(6){
    width: 100%;
    height: 180px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}

/* 横向放置的手机及分辨率更小的设备 */
@media (max-width: 480px) {
  .intelligent_scene_nav{
    width: 92%;
    margin: 0 auto;
  }

  .item_padding{
    padding: 0 0.6rem;
  }
  .small_icon{
    display: none;
  }
  .intelligent_scene_content{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 1rem 0;
  }
  .content_left_image {
    width: 88%;
    height: auto;
  }
  .content_right_word {
    width: 86%;
    padding: 1rem 0;
  }
  .content_word_span{
    font-size: 15px;
    display: block;
    color: #666666;
    font-weight: 400;
    width: 100%;
    margin-top: 9px;
  }
  .case_display_box{
    width: 100%;
    background: #F5F6F9;
    margin: 0 auto;
  }
  .case_display_title{
    width: 100%;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
    padding-top: 1.7rem;
  }
  .smart_community_box{
    width: 100%;
    height: 32rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .smart_community_left{
    width: 100%;
    height: 17rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .smart_community_right{
    width: 100%;
    height: 23rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .smart_community_btn{
    width: 9.75rem;
    height: 32px;
    line-height: 32px;
    border: 1px solid #3271FF;
    color: #3271FF;
    background-color: rgba(0,0,0,0);
    margin: 2rem auto;
  }
  .smart_community_image{
    width: 80%;
    height: auto;
  }
  .big_data_box{
    width: 100%;
    height: 32rem;
  }
  .company_data_title{
    width: 100%;
    height: 7.75rem;
    text-align: center;
    line-height: 7.75rem;
    font-size: 1.5rem;
    font-weight: 600;
  }
  .company_data_content{
    width: 92%;
    margin:  auto;
    display: flex;
    justify-content: space-between;
    padding-bottom: 3rem;
  }
  .one_content_list{
    width: 48%;
    margin-bottom: 1rem;
  }
  .one_content_image{
    width: 100%;
  }
  .process_image_word{
    width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 3.5rem 0;
  }
  .process_one_image{
    width: 32px;
    height: 32px;
    -webkit-user-drag: none;
  }
  .process_image_span{
    padding: 0.5rem 0;
    font-size: 14px;
    width: 140px;
    text-align: center
  }
  .arrow_style{
    height: 47px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 1rem 2rem;
  }
  .cooperative_unit_title{
    width: 100%;
    height: 100px;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
    line-height: 100px;
  }
  .cooperative_unit_content img{
    padding: 5px;
    width:50%;
    height: auto;
  }
  .cooperative_unit_content img:nth-of-type(5){
    padding: 5px;
    width:24% !important;
    height: auto;
  }
  .small_digital_service{
    width: 100%;
    height: 226px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .digital_service_title{
    width: 100%;
    height: 4.75rem;
    text-align: center;
    line-height: 8.75rem;
    font-size: 1.5rem;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue